/* global dcLoginData */

// Login page customizations

(function () {
  const $h1 = jQuery('h1[class="wp-login-logo"]');
  // const $h1 = jQuery('h1[class!="admin-email__heading"]');

  // console.log('$h1', $h1);

  if (window.dcLoginData && dcLoginData.loginHeaderHtml) {
    // console.log(dcLoginData.loginHeaderHtml);
    $h1.after(dcLoginData.loginHeaderHtml);
  }

  $h1.hide();
}());
